import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as filters from '@/util/filters'
import VueMeta from 'vue-meta'
import Auth from '@/services/initAuth'
import "@/assets/scss/_fake.scss"
import RouterNames from "./router/router-const"
import Dayjs from "dayjs"
import PortalVue from "portal-vue"
import Notifications from 'vue-notification'
import velocity      from 'velocity-animate'
import infiniteScroll from 'vue-infinite-scroll'
import ExerciseAuth from "@/services/ExerciseInitAuth"
import relativeTime from "dayjs/plugin/relativeTime";
import Fragment from 'vue-fragment'
import SummernotePlugin from "@/plugins/summernote"

require('bootstrap')

Vue.config.productionTip = false
export const auth = Object.freeze(Auth)

Dayjs.extend(relativeTime)

Vue.prototype.$ROUTER_NAMES = RouterNames
Vue.prototype.$auth = ExerciseAuth
Vue.prototype.$dates = Dayjs

Vue.use(SummernotePlugin);

Vue.use(PortalVue)
Vue.use(Notifications, { velocity })
Vue.use(infiniteScroll)
Vue.use(VueMeta)
Vue.use(Fragment.Plugin)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
